(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kubbi-k47-feature-rail"] && !Shopify.designMode) return;
  try {
    
(function(){
  function animateCount(el){
    if(el.dataset.done) return;
    var raw=(el.dataset.stat||'').trim();
    if(!/^[\d][\d,.\s]*$/.test(raw)){ el.dataset.done='1'; return; }
    el.dataset.done='1';
    var target=parseFloat(raw.replace(/[,\s]/g,''));
    if(isNaN(target)){ return; }
    var t0=null, dur=1100;
    function step(ts){ if(!t0)t0=ts; var p=Math.min(1,(ts-t0)/dur); var e=1-Math.pow(1-p,3);
      el.textContent=Math.round(target*e).toLocaleString('en-GB'); if(p<1)requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  function setup(sec){
    var rail=sec.querySelector('[data-rail]'); if(!rail) return;
    var cards=[].slice.call(rail.querySelectorAll('.k47rail__card'));
    var track=sec.querySelector('[data-track]');
    // prime numeric stats to 0
    cards.forEach(function(c){ c.querySelectorAll('.k47rail__num').forEach(function(n){ var r=(n.dataset.stat||'').trim(); if(/^[\d][\d,.\s]*$/.test(r)) n.textContent='0'; }); });
    // COUNT-UP: fire on EVERY card the moment it is visible (not only the active one)
    if('IntersectionObserver' in window){
      var cio=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.querySelectorAll('.k47rail__num').forEach(animateCount); } }); },{root:null,threshold:0.25});
      cards.forEach(function(c){ cio.observe(c); });
    } else {
      cards.forEach(function(c){ c.querySelectorAll('.k47rail__num').forEach(animateCount); });
    }
    // PHONE: stacked cards that slide in on scroll (no horizontal rail)
    if(window.matchMedia('(max-width:780px)').matches){
      if('IntersectionObserver' in window){
        var mio=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); mio.unobserve(e.target); } }); },{threshold:0.3});
        cards.forEach(function(c){ mio.observe(c); });
      } else {
        cards.forEach(function(c){ c.classList.add('in'); });
      }
      return;
    }
    function step(){ return cards.length>1 ? (cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left) : (cards[0].offsetWidth+18); }
    function update(){
      var rc=rail.getBoundingClientRect(), mid=rc.left+rc.width/2, best=0, bd=1e9;
      cards.forEach(function(c,i){ var b=c.getBoundingClientRect(); var d=Math.abs(b.left+b.width/2-mid); if(d<bd){bd=d;best=i;} });
      cards.forEach(function(c,i){ c.classList.toggle('is-active',i===best); });
      if(track){ var max=rail.scrollWidth-rail.clientWidth; var p=max>0?rail.scrollLeft/max:0; var w=100/cards.length; track.style.width=w+'%'; track.style.marginLeft=(p*(100-w))+'%'; }
    }
    var raf;
    rail.addEventListener('scroll',function(){ cancelAnimationFrame(raf); raf=requestAnimationFrame(update); },{passive:true});
    var down=false,sx=0,sl=0,moved=false;
    rail.addEventListener('pointerdown',function(e){ down=true;moved=false;sx=e.clientX;sl=rail.scrollLeft;rail.classList.add('is-drag');rail.style.scrollBehavior='auto'; });
    window.addEventListener('pointerup',function(){ down=false;rail.classList.remove('is-drag');rail.style.scrollBehavior='smooth'; });
    window.addEventListener('pointermove',function(e){ if(!down)return; if(Math.abs(e.clientX-sx)>4)moved=true; rail.scrollLeft=sl-(e.clientX-sx); });
    rail.addEventListener('click',function(e){ if(moved){ e.preventDefault(); } },true);
    sec.querySelectorAll('.k47rail__btn').forEach(function(b){
      b.addEventListener('click',function(){ rail.scrollBy({left:(+b.dataset.dir)*step(),behavior:'smooth'}); });
    });
    rail.style.scrollBehavior='smooth';
    update(); setTimeout(update,60);
  }
  document.querySelectorAll('.k47rail').forEach(setup);
  document.addEventListener('shopify:section:load',function(e){ var s=e.target.querySelector('.k47rail'); if(s) setup(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kubbi-k47-features"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var cards=[].slice.call(root.querySelectorAll('.reveal'));
    if(!('IntersectionObserver' in window)){cards.forEach(function(c){c.classList.add('in');});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var row=root.querySelectorAll('.reveal');
          var i=[].indexOf.call(row,e.target);
          e.target.style.transitionDelay=((i>=0?i%4:0)*90)+'ms';
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },{threshold:0.15});
    cards.forEach(function(c){io.observe(c);});
  }
  document.querySelectorAll('.k47feat').forEach(init);
  document.addEventListener('shopify:section:load',function(e){var s=e.target.querySelector('.k47feat');if(s)init(s);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kubbi-k47-megastat"] && !Shopify.designMode) return;
  try {
    
(function(){
  function animateCount(el){
    if(el.dataset.done) return;
    var raw=(el.dataset.count||'').trim();
    // only animate clean numbers (allow comma / space thousands); leave text like "UK-backed" alone
    if(!/^[\d][\d,.\s]*$/.test(raw)){ el.dataset.done='1'; return; }
    el.dataset.done='1';
    var target=parseFloat(raw.replace(/[,\s]/g,''));
    if(isNaN(target)){ return; }
    var t0=null, dur=1300;
    function step(ts){ if(!t0)t0=ts; var p=Math.min(1,(ts-t0)/dur); var e=1-Math.pow(1-p,3);
      el.textContent=Math.round(target*e).toLocaleString('en-GB'); if(p<1)requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  function setup(sec){
    var counts=[].slice.call(sec.querySelectorAll('.k47ms__count'));
    if(!counts.length) return;
    var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    // prime numeric counters to 0
    counts.forEach(function(n){ var r=(n.dataset.count||'').trim(); if(/^[\d][\d,.\s]*$/.test(r)) n.textContent='0'; });
    if(reduce || !('IntersectionObserver' in window)){
      counts.forEach(animateCount); return;
    }
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ counts.forEach(animateCount); io.disconnect(); } });
    },{threshold:0.35});
    io.observe(sec);
  }
  document.querySelectorAll('.k47ms').forEach(setup);
  document.addEventListener('shopify:section:load',function(e){ var s=e.target.querySelector('.k47ms'); if(s) setup(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kubbi-k47-specs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var tab = e.target.closest('.kubbi-specs__tab');
  if (!tab) return;
  var sec = tab.closest('.kubbi-specs');
  if (!sec) return;
  var t = tab.getAttribute('data-tab');
  sec.querySelectorAll('.kubbi-specs__tab').forEach(function (x) {
    x.classList.toggle('is-active', x === tab);
  });
  sec.querySelectorAll('.kubbi-specs__panel').forEach(function (p) {
    p.classList.toggle('is-active', p.getAttribute('data-panel') === t);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kubbi-s7-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  function ac(el){if(el.dataset.done)return;el.dataset.done='1';var raw=(el.dataset.count||'').trim();if(!/^[\d][\d,.\s]*$/.test(raw)){return;}var t=parseFloat(raw.replace(/[,\s]/g,''));if(isNaN(t))return;var s=null,d=1300;function st(x){if(!s)s=x;var p=Math.min(1,(x-s)/d);el.textContent=Math.round(t*(1-Math.pow(1-p,3))).toLocaleString('en-GB');if(p<1)requestAnimationFrame(st);}requestAnimationFrame(st);}
  function setup(root){
    var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    root.querySelectorAll('.s7-count').forEach(function(n){var r=(n.dataset.count||'').trim();if(/^[\d][\d,.\s]*$/.test(r))n.textContent='0';});
    var items=root.querySelectorAll('.reveal,.reveal-l,.reveal-r,.reveal-pop');
    if(reduce || !('IntersectionObserver' in window)){
      items.forEach(function(el){el.classList.add('in');});
      root.querySelectorAll('.s7-count').forEach(ac);
      return;
    }
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');e.target.querySelectorAll('.s7-count').forEach(ac);io.unobserve(e.target);}});},{threshold:0.18});
    items.forEach(function(el){io.observe(el);});
    // any counts not wrapped in a reveal element
    root.querySelectorAll('.s7-count').forEach(function(c){if(!c.closest('.reveal,.reveal-l,.reveal-r,.reveal-pop'))io.observe(c);});
  }
  document.querySelectorAll('.s7l').forEach(setup);
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.s7l');if(r)setup(r);});
})();

  } catch(e) { console.error(e); }
})();
})();
